import React, { useEffect, lazy, useState } from 'react';
import { useLocation, useRouteMatch } from 'react-router-dom';
import './checklist.less';
import ReportChecklistBoshDescription from '@/components/Reports/ReportPublic/ReportChecklist/ReportChecklistDescription';
import ReportChecklistDamage from '@/components/Reports/ReportPublic/ReportChecklist/ReportChecklistDamage';
import ReportChecklistHeader from '@/components/Reports/ReportPublic/ReportChecklist/ReportChecklistHeader';
import ReportChecklistAccessories from '@/components/Reports/ReportPublic/ReportChecklist/ReportChecklistAccessories';
import ReportChecklistFooter from '@/components/Reports/ReportPublic/ReportChecklist/ReportChecklistFooter';
import { useAccessoryList } from '@/core/domain/people/Accessory/Accessory.hooks';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { useCompany } from '@/core/domain/enterprise/Companies/Companies.hooks';
import { useCompanyReportConfig } from '@/core/domain/enterprise/Companies/CompaniesReportConfig/CompaniesReportConfig.hooks';

const TemplateReport = lazy(
  () => import('@/components/_common/TemplateReport/TemplateReport'),
);

type SearchParams = Record<'companyId', string>;

const PrivateReportChecklistEmpty: React.FC = () => {
  const match = useRouteMatch();
  const { search } = useLocation();
  const params = Object.fromEntries(
    new URLSearchParams(search),
  ) as SearchParams;
  const [imageLoaded, setImageLoaded] = useState(false);
  const companyData = useCompany(Number(params.companyId));

  const accessoriesData = useAccessoryList({ rows: 200, active: true });

  const accessories = flatInfiniteData(accessoriesData.data);

  const { data: configCompany } = useCompanyReportConfig(
    !!params.companyId ? params.companyId : undefined,
  );

  useEffect(() => {
    if (companyData.data && imageLoaded) {
      document.title = `Checklist_em_branco-${companyData.data?.name
        .split(' ')
        .join('_')}`;

      (async () => {
        if (companyData.data.logo && imageLoaded) {
          await fetch(companyData.data.logo);
        }
        setTimeout(() => {
          window.print();
        }, 500);
      })();
    }
  }, [companyData.dataUpdatedAt, imageLoaded]);

  return (
    <React.Suspense fallback={<>Carregando documento...</>}>
      {match.isExact && !!accessories && !!companyData.data && (
        <TemplateReport>
          <main className="reportChecklist">
            <ReportChecklistHeader
              setLoaded={setImageLoaded}
              company={{
                bosch: false,
                cnpj: companyData.data.cnpj,
                email: '',
                filePath: companyData.data.logo || '',
                name: companyData.data.name,
                nickName: companyData.data.nickName,
                id: companyData.data.id,
              }}
              companyConfig={configCompany}
            />

            <ReportChecklistBoshDescription isEmpty />

            <ReportChecklistDamage />

            <ReportChecklistAccessories
              isEmpty
              accessories={accessories.map((item) => ({
                accessoryId: item.id,
                comment: '',
                description: item.description,
                selected: false,
              }))}
            />

            <ReportChecklistFooter />
          </main>
        </TemplateReport>
      )}
    </React.Suspense>
  );
};

export default PrivateReportChecklistEmpty;
